
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupDetailProjection, ILookupModifyProjectionParameter, IMetadataAction, KeyValue, LookupModifyAvailability } from "@tylertech/tyler-api-types";

/**
 * CodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class CodeLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Get(type: string, filterString?: string): Promise<KeyValue[]> {
        return this.$apiService.sendAuth("ICodeLookupService/Get", type, filterString);
    }
    GetLookupDetailProjection(type: string): Promise<ILookupDetailProjection> {
        return this.$apiService.sendAuth("ICodeLookupService/GetLookupDetailProjection", type);
    }
    GetLookupModifyAvailability(type: string): Promise<LookupModifyAvailability> {
        return this.$apiService.sendAuth("ICodeLookupService/GetLookupModifyAvailability", type);
    }
    GetLookupModifyProjection(lookupModifyProjectionParameter: ILookupModifyProjectionParameter): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("ICodeLookupService/GetLookupModifyProjection", lookupModifyProjectionParameter);
    }
}
